const EDUCATION_RESERVATION_ERROR_CODE = {
  NOT_IN_PROGRESS: -1415,
  NOT_EXPOSED: -1416,
  CLASS_NOT_EXPOSED: -1409,
  CLASS_NOT_IN_RESERVATION: -1410,
};

export default EDUCATION_RESERVATION_ERROR_CODE;
